import { useEffect, useState } from 'react';
import { getNowIndicatorPosition } from '../../lib/timeline';

interface PlannerNowIndicatorProps {
  startHour: number;
  endHour: number;
  pxPerHour: number;
}

export function PlannerNowIndicator({ startHour, endHour, pxPerHour }: PlannerNowIndicatorProps) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(interval);
  }, []);

  const position = getNowIndicatorPosition(now, startHour, endHour, pxPerHour);
  if (!position) return null;

  const timeStr = now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

  return (
    <div className="absolute left-0 right-0 z-30 pointer-events-none" style={{ top: position.top }}>
      <div className="absolute -left-[3px] -top-[3px] w-1.5 h-1.5 rounded-full bg-accent" />
      <div className="absolute left-0 right-0 border-t border-accent/50" />
      <span className="absolute right-1 -top-4 text-[10px] font-mono font-medium text-accent select-none leading-none whitespace-nowrap">
        {timeStr}
      </span>
    </div>
  );
}
